<template>
    <Flyout
        v-if="tourStep === REDESIGN_TOUR_STEPS.STEP_2_HOW_TO_FAVORITE && tourMenuItemTop && tourMenuItemLeft"
        :z-index="TOUR_CARD_Z_INDEX"
        ref="root"
        force-open
        disable-trigger
        disable-auto-close-flyout
        show-guide-mark
        data-test-tag="tour-flyout"
        class="favorite-pages-tour-card"
        :style="positionStyle"
        placement="right"
    >
        <template #default>
            <TourCard
                :tour-step="REDESIGN_TOUR_STEPS.STEP_2_HOW_TO_FAVORITE"
                :next-tour-step="REDESIGN_TOUR_STEPS.STEP_3_MANAGE_FAVORITES"
                tour-heading-translation-key="tourNavRedesign_tourStop2_headingFavoritePageAction"
                tour-description-translation-key="tourNavRedesign_tourStop2_description"
                data-test-tag="tour-step-2"
            />
        </template>
    </Flyout>
</template>

<script>
import { defineComponent, nextTick } from 'vue';
import Flyout from './Flyout.vue';
import TourCard from './tour/TourCard.vue';
import { REDESIGN_TOUR_STEPS, useNavRedesignTourStore } from '../../stores/navRedesignTourStore';
import { mapState } from 'pinia';
import { TOUR_CARD_Z_INDEX } from '../../constants/tour';

export default defineComponent({
    components: { TourCard, Flyout },
    computed: {
        ...mapState(useNavRedesignTourStore, ['tourStep', 'tourMenuItemTop', 'tourMenuItemLeft']),
        REDESIGN_TOUR_STEPS() {
            return REDESIGN_TOUR_STEPS;
        },
        TOUR_CARD_Z_INDEX() {
            return TOUR_CARD_Z_INDEX;
        },
        positionStyle() {
            const topOffset = -2;
            return `top: ${this.tourMenuItemTop + topOffset}px; left: ${this.tourMenuItemLeft}px;`;
        },
    },
});
</script>

<style lang="scss" scoped>
.favorite-pages-tour-card {
    position: absolute;
}
</style>
